<template>
  <div class="eol-container-box">
    <div class="step-outer-box">
      <div class="bottom-all-box" v-if="workDetail&&workDetail.work">
        <a-button type="link" class="back-class-btn" @click="$router.push(`/${school_code}/school/activity/hall?id=${activity_id}`)">{{backTxt}}</a-button>
        <div class="bottom-all-scroll">
          <div class="step-profile">
            <div class="profile-item">
              <div class="profile-label">提交人</div>
              <div class="profile-content" v-for="item,index in workDetail.member" :key="index">
                <span class="mr">姓名：{{ item.name }}</span>
                <span class="mr">账号名：{{ item.username }}</span>
                <span class="mr">手机号：{{ item.mobile?item.mobile:'暂无' }}</span>
                <span class="mr">所属班级：{{ item.class_name }}</span>
              </div>
            </div>

            <div class="profile-item has-file">
              <div class="profile-label">任务说明</div>
              <div class="profile-content">
                <div class="text-scroll" v-html="workDetail.work.description"></div>
                <div class="files" v-if="workDetail.resource.filter(i => i.is_model == 2) && workDetail.resource.filter(i => i.is_model == 2).length > 0">
                  <div class="file-label">作业<br>附件</div>
                  <div :class="['profile-files',{alignCenter: (workDetail.resource.filter(i => i.is_model == 2)).length < 3 ?'alignCenter':''}]">
                    <div class="file-item" v-for="item,index in workDetail.resource.filter(i => i.is_model == 2)" :key="index">
                      <div class="file-name">
                        <a-tooltip overlayClassName="intro-tooltip-box" placement="bottom">
                          <template slot="title">
                            附件{{`${index+1}：`}}{{item.filename}}.{{item.file_format}}
                          </template>
                          附件{{`${index+1}：`}}{{item.filename}}.{{item.file_format}}
                        </a-tooltip>
                      </div>
                      <div class="file-button">
                        <div class="button-item" @click="previewRes(item)">查看</div>
                        <div class="button-item" @click="downloadRes(item,1)">下载</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="profile-item" v-if="workDetail.resource.filter(i => i.is_model == 1) && workDetail.resource.filter(i => i.is_model == 1).length > 0">
              <div class="profile-label">参照样例</div>
              <div class="profile-files">
                <div class="file-item" v-for="item,index in workDetail.resource.filter(i => i.is_model == 1)" :key="index">
                  <div class="file-name">
                    <a-tooltip overlayClassName="intro-tooltip-box" placement="bottom">
                      <template slot="title">
                        {{item.filename}}.{{item.file_format}}
                      </template>
                      {{item.filename}}.{{item.file_format}}
                    </a-tooltip>
                  </div>
                  <div class="file-button">
                    <div class="button-item" @click="previewRes(item)">查看</div>
                    <div class="button-item" @click="downloadRes(item,1)">下载</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="step-content">
            <div class="step-label">任务提交</div>
            <div class="step-upload">
              <div class="file-list">
                <div v-for="(item, index) in workDetail.attachment" :key="index" :class="['file-item', `status-${item.covert_status}`]">
                  <div class="file-upper">
                    <!-- 文件封面 docx显示默认封面 -->
                    <div class="file-cover" :class="{ 'file-docx': item.type == 4 }" :style="(item.type == 1 || (item.type == 3&&item.covert_status == 2)) ? `background:url(${item.cover||item.view_url}) no-repeat center/cover` : ''">
                    </div>
                    <div class="file-mask"></div>
                    <!-- 转码中 -->
                    <div class="file-translate" v-if="item.type != 1 && item.type != 2  && item.covert_status == '1'"></div>
                    <div class="file-translate transerror" v-if="item.type != 1 && item.type != 2 && item.covert_status == '3'"></div>
                  </div>
                  <div class="file-name">
                    <div class="name-text">{{item.filename}}.{{item.file_format}}</div>
                    <div class="button-group" v-if="item.covert_status != '3'">
                      <div class="button-item" @click="previewRes(item)">预 览</div>
                      <div class="button-item" @click="downloadRes(item,2)">下 载</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="bottom-score">
          <div class="score-full">分值：{{Number(workDetail.work.total_score)}}分</div>
          <div class="score-input"><a-input-number :min="0" :max="Number(workDetail.work.total_score)" step="0.01" :autoFocus="true" v-model="score"></a-input-number></div>
          <div class="score-submit" @click="submitScore()">确定</div>
        </div>
      </div>

    </div>
    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${downloadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>
    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { downloadFile, downloadVideoFile, getDownloadUrl } from '../../../assets/js/downloadUtils'; // 引入封装的方法
import imageViewer from '../../../assets/js/imageViewer';
// 讲展馆故事- 批阅
export default {
  name: 'hallMark',
  components: {
    PreviewPdf: () => import('../../../components/PreviewPdf'),
    PlayBox: () => import('../../../components/PlayBox'),
  },
  data () {
    return {
      backTxt: '< 返回',
      school_code: localStorage.getItem("schoolCode"),
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      score: 0,
      task_id: "t009", // 讲展馆故事名称
      work_id: '', // 作业id
      activity_id: '', // 活动id
      downloadProgress: 0,
      loading: false,
    }
  },
  computed: {
    ...mapState({
      workDetail: state => state.teachEvent.workDetail,
    }),
  },
  async mounted () {
    this.activity_id = this.$route.query.id
    this.work_id = this.$route.query.work_id
    await this.getWorkDetail({ id: this.work_id, activity_id: this.activity_id, task_id: this.task_id, })
    this.score = await Number(this.workDetail.work.score)
  },
  methods: {
    ...mapActions(["getWorkDetail", "postWorkScore"]),

    // 下载附件
    async downloadRes (row, downloadType) {
      try {
        this.loading = true;
        this.downloadProgress = 0;

        if (downloadType == 1) {
          // 课程资源下载
          if (row.type == 3) {
            // 视频文件下载
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl("/api/school/train/course/resource/download", {
              id: row.id,
              course_id: this.workDetail.work.course_id,
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        } else {
          // 作业附件下载
          if (row.type != 1 && row.type != 2 && row.covert_status == 1) {
            return this.$message.error("请等待转码完成后下载");
          }
          if (row.type == 3) {
            // 视频文件
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl(`/api/school/train/work/attachment/download`, {
              id: row.id,
              activity_id: this.activity_id
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        }
      } catch (error) {
        console.error("下载失败", error);
        this.$message.error("下载失败");
      } finally {
        this.loading = false;
      }
    },

    // 预览资源
    previewRes (item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1) {
        imageViewer.open(item.view_url)
      } else if (item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
    // 提交评分
    submitScore () {
      this.postWorkScore({ task_id: this.task_id, activity_id: this.activity_id, work_id: this.work_id, score: this.score, _method: 'put' }).then(res => {
        if (res.code == "0000") {
          this.$message.success(`操作成功`)
          if (this.workDetail.next_id) {
            this.$router.push(`/${this.school_code}/school/activity/draw/mark?id=${this.activity_id}&work_id=${this.workDetail.next_id}`)
            this.getWorkDetail({ id: this.workDetail.next_id, activity_id: this.activity_id, task_id: this.task_id, })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    .bottom-all-box {
        position: relative;
        width: 1200px;
        margin: 0 auto;
        height: calc(100vh - 160px);
        .back-class-btn {
            padding: 0 16px;
            height: 32px;
            background: #b84b3c;
            border-radius: 16px;
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            margin-bottom: 15px;
            line-height: 32px;
            &:hover {
                background: #a82822;
            }
        }
        .bottom-all-scroll {
            height: calc(100% - 80px);
            overflow-y: auto;
            border: 1px solid #e7eaec;
            padding: 18px 25px 0;
            .step-profile {
                .profile-item {
                    display: flex;
                    &:not(:last-child) {
                        margin-bottom: 14px;
                    }
                    .profile-label {
                        width: 86px;
                        height: 28px;
                        background: #bc7a6e;
                        border-radius: 14px 0px 0px 14px;
                        line-height: 28px;
                        font-weight: bold;
                        font-size: 14px;
                        color: #ffffff;
                        padding: 0 14px;
                        text-align: center;
                    }
                    .profile-content {
                        flex: 1;
                        background: #f8f8f8;
                        border-radius: 4px;
                        font-size: 14px;
                        color: #2f2626;
                        line-height: 18px;
                        min-height: 30px;
                        height: max-content;
                        max-height: 120px;
                        overflow-y: auto;
                        padding: 5px 22px;
                        p {
                            width: 100%;
                        }
                        .mr {
                            width: 17%;
                            display: inline-block;
                            text-align: left;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            &:not(:last-child) {
                                margin-right: 2%;
                            }
                            &:first-child {
                                width: 26%;
                            }
                        }

                        &.profile-scroll {
                            padding: 5px 5px 0 22px;
                            .scroll-inner {
                                padding: 6px 0;
                                max-height: 120px;
                                overflow-y: auto;
                                p:not(:last-child) {
                                    margin-bottom: 2px;
                                }
                            }
                        }
                    }
                    .profile-files {
                        flex: 1;
                        background: #f8f8f8;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;
                        padding: 5px 22px 0;
                        max-height: 82px;
                        overflow-y: auto;
                        &.alignCenter {
                            align-content: center;
                        }
                        .file-item {
                            width: calc(100% / 3);
                            display: flex;
                            align-items: center;
                            margin-bottom: 5px;
                            &:nth-child(3n)::after {
                                display: none;
                            }
                            &::after {
                                content: '';
                                display: inline-block;
                                width: 1px;
                                height: 16px;
                                background: #e8e4e4;
                                margin: 0 16px 0 21px;
                            }
                            .file-name {
                                font-size: 14px;
                                color: #606163;
                                flex: 1;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                padding-right: 10px;
                            }
                            .file-button {
                                display: flex;
                                align-items: center;
                                .button-item {
                                    cursor: pointer;
                                    &:not(:last-child) {
                                        margin-right: 24px;
                                    }

                                    font-size: 14px;
                                    color: #b84b3c;
                                }
                            }
                            &:last-child::after {
                                opacity: 0;
                            }
                        }
                    }
                    &.has-file {
                        .profile-content {
                            max-height: unset;
                            padding-bottom: 8px;
                        }
                        .text-scroll {
                            max-height: 115px;
                            overflow-y: auto;
                        }
                        .files {
                            display: flex;
                            margin-top: 8px;
                            background: #fff;
                            padding: 5px 15px 5px 0;
                            .file-label {
                                width: 44px;
                                height: 38px;
                                background: url('../../../assets/image/school/teach/work-file.png')
                                    no-repeat center/cover;
                                font-size: 12px;
                                color: #ffffff;
                                padding: 5px 0 0 7px;
                                line-height: 1.2;
                                margin-right: 15px;
                                flex-shrink: 0;
                            }
                            .profile-files {
                                padding: 0;
                                background: transparent;
                                .file-item {
                                    width: 50%;
                                    .file-name {
                                        font-size: 12px;
                                        color: #4f4f58;
                                    }

                                    .file-button {
                                        .button-item {
                                            font-size: 12px;
                                            color: #dfa267;
                                        }
                                    }
                                    &::after {
                                        margin: 0 15px;
                                    }
                                    &:nth-child(3n)::after {
                                        display: block;
                                    }

                                    &:nth-child(2n)::after {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .step-content {
                padding: 20px 0 30px;
                .step-label {
                    font-weight: bold;
                    font-size: 14px;
                    color: #ffffff;
                    width: 100%;
                    height: 32px;
                    background: #b84b3c;
                    line-height: 32px;
                    padding: 0 15px;
                }
                .step-upload {
                    padding: 20px 16px;
                    background: #f8f8f8;
                    display: flex;
                    align-items: center;
                    .upload-button {
                        width: 92px;
                        height: 32px;
                        background: #fff3f2;
                        border-radius: 16px;
                        border: 1px solid #cc9d9a;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        color: #a82822;
                        cursor: pointer;
                        margin-right: 20px;
                    }
                    .upload-text {
                        font-size: 12px;
                        color: #9fa4aa;
                    }
                }

                .file-list {
                    display: flex;
                    gap: 22px;
                    flex-wrap: wrap;
                    .file-item {
                        position: relative;
                        width: 236px;
                        cursor: pointer;
                        .file-upper {
                            width: 100%;
                            height: auto;
                            aspect-ratio: 236/133;
                            position: relative;
                            overflow: hidden;
                            .file-cover {
                                width: 100%;
                                height: 100%;
                                transition: all 0.3s;
                                &.file-docx {
                                    background: #e5ecfa;
                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        width: 53px;
                                        height: 63px;
                                        background: url('../../../assets/image/student/unitTwo/file-word.png')
                                            no-repeat center/cover;
                                    }
                                }
                            }

                            .file-translate {
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                z-index: 1;
                                background: url('../../../assets/image/student/unitTwo/translate.png')
                                    no-repeat center/cover;
                                &.transerror {
                                    background: url('../../../assets/image/student/unitTwo/transerror.jpg')
                                        no-repeat center/cover;
                                }
                            }
                        }
                        .file-name {
                            background: #ffffff;
                            border: 1px solid #e7eaec;
                            padding: 9px 14px;
                            height: 104px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .name-text {
                                font-size: 14px;
                                color: #3c3c3e;
                                word-break: break-all;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                            }
                            .button-group {
                                display: flex;
                                align-items: center;

                                .button-item {
                                    font-size: 14px;
                                    color: #a82822;
                                    width: calc(50% - 2px);
                                    height: 28px;
                                    background: #ffecee;
                                    text-align: center;
                                    line-height: 28px;
                                    border-radius: 0px 14px 14px 0px;
                                    &:hover {
                                        background: #ffe3e1;
                                    }
                                    &:not(:last-child) {
                                        margin-right: 4px;
                                        border-radius: 14px 0px 0px 14px;
                                    }
                                }
                            }
                        }

                        .file-play {
                            width: 36px;
                            height: 36px;
                            background: url('../../../assets/image/common/video-play.png')
                                no-repeat center/cover;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            z-index: 1;
                            opacity: 1;
                        }

                        .file-mask {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            background: rgba(60, 60, 62, 0.6);
                            transition: all 0.3s;
                            opacity: 0;
                        }

                        &:hover {
                            .file-upper {
                                .file-cover {
                                    transform: scale(1.1);
                                }
                                .file-delete {
                                    background: linear-gradient(
                                        90deg,
                                        #c0403a 3%,
                                        #bb1c15 100%
                                    );
                                    border: 1px solid #cc9d9a;
                                    opacity: 0.94;
                                    &::before {
                                        background: url('../../../assets/image/student/unitTwo/delete-white.png')
                                            no-repeat center/cover;
                                    }
                                }
                            }
                        }

                        // 转码中
                        &.translate {
                            .file-mask {
                                opacity: 0;
                            }

                            &:hover {
                                .file-mask {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }
        }

        .bottom-score {
            margin-top: 24px;
            position: sticky;
            bottom: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .score-full {
                font-size: 14px;
                color: #3c3c3e;
            }
            .ant-input-number {
                margin-left: 8px;
                width: 75px;
                height: 32px;
                background: #ffffff;
                border: 1px solid #e7eaec;
                text-align: center;
                line-height: 32px;
                box-shadow: none !important;
                border-radius: 0;
                padding-right: 2px;
                /deep/ .ant-input-number-handler-wrap {
                    width: 12px;
                    opacity: 1;
                    .ant-input-number-handler {
                        width: 100%;
                        position: relative;
                        height: 14px !important;
                        background: #e7eaec;
                        &:not([aria-disabled='true']):hover {
                            i {
                                &.anticon-up {
                                    background: url('../../../assets/image/school/common/number-up-active.png')
                                        no-repeat center/cover;
                                }
                                &.anticon-down {
                                    background: url('../../../assets/image/school/common/number-down-active.png')
                                        no-repeat center/cover;
                                }
                            }
                        }
                        &:last-child {
                            margin-top: 2px;
                        }
                        i {
                            width: 7px;
                            height: 6px;
                            top: 50%;
                            right: 50%;
                            transform: scale(1) rotate(0deg) !important;
                            svg {
                                display: none;
                            }
                            &.anticon-up {
                                background: url('../../../assets/image/school/common/number-up.png')
                                    no-repeat center/cover;
                                top: 9px;
                                right: 2px;
                            }
                            &.anticon-down {
                                background: url('../../../assets/image/school/common/number-down.png')
                                    no-repeat center/cover;
                                top: 10px;
                                right: 2px;
                            }
                        }
                    }
                }
            }
            .score-submit {
                width: 60px;
                height: 32px;
                background: #a82822;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
                font-size: 14px;
                color: #ffffff;
            }
        }
    }
}
@media screen and (max-width: 1600px) {
    .step-outer-box
        .bottom-all-box
        .bottom-all-scroll
        .step-profile
        .profile-item
        .profile-files
        .file-item {
        width: 50%;
        &:nth-child(3n)::after {
            display: block;
        }

        &:nth-child(2n)::after {
            display: none;
        }
    }
    .step-outer-box .bottom-all-box {
        width: 100%;
    }
}
</style>